import waterMark from '@/assets/images/e-commerce/waterMark.png';
import iconAudioWhite from '@/assets/images/media-icons/icon-audio-white.png';
import iconImageWhite from '@/assets/images/media-icons/icon-image-white.png';
import iconVideoWhite from '@/assets/images/media-icons/icon-video-white.png';
import ImageView from '@/components/ui/ImageView/ImageView';
import { EcItemSaleStatus, EcItemSaleStatusType, EcItemType, EcItemTypeType } from '../../types';
import { ecItemStatusColor } from '../../utils';
import styles from './EcItemThumbnail.module.scss';

function EcItemThumbnail({
  thumbnailUrl,
  showWaterMark = false,
  itemType,
  saleStatus,
}: {
  thumbnailUrl?: string;
  showWaterMark?: boolean;
  itemType?: EcItemTypeType;
  saleStatus?: EcItemSaleStatusType;
}) {
  return (
    <div className={styles.componentStyle}>
      <ImageView src={thumbnailUrl}></ImageView>
      {showWaterMark && (
        <div className={styles.waterMark}>
          <ImageView src={waterMark.src}></ImageView>
        </div>
      )}
      {itemType && <div className={styles.mediaIconContainer}>{itemTypeIcon(itemType)}</div>}
      {saleStatus && (
        <div
          className={styles.itemStatusLabel}
          style={{ backgroundColor: `var(--color-${ecItemStatusColor(saleStatus)})` }}
        >
          <span className={styles.labelText}>{statusLabelTextNode(saleStatus)}</span>
        </div>
      )}
    </div>
  );
}

function itemTypeIcon(ecItemType: EcItemTypeType) {
  switch (ecItemType) {
    case EcItemType.image.value:
      return <img src={iconImageWhite.src} alt='' className={styles.iconImage}></img>;
    case EcItemType.video.value:
      return <img src={iconVideoWhite.src} alt='' className={styles.iconVideo}></img>;
    case EcItemType.audio.value:
      return <img src={iconAudioWhite.src} alt='' className={styles.iconAudio}></img>;
    default:
      return <></>;
  }
}

function statusLabelTextNode(status: EcItemSaleStatusType) {
  switch (status) {
    case EcItemSaleStatus.on_sale.value:
      return <>販売中</>;
    case EcItemSaleStatus.upcoming.value:
      return (
        <>
          販売
          <br />
          予定
        </>
      );
    case EcItemSaleStatus.later.value:
      return (
        <>
          販売
          <br />
          終了
        </>
      );
    case EcItemSaleStatus.sold.value:
      return <>完売</>;
    default:
      return <></>;
  }
}

export default EcItemThumbnail;
